// app/src/lib/progress-map.js — pipeline step events -> the handoff's plain-language
// pipeline list (Wrote the script / Designed the look / Filming scenes / Voiceover & music /
// Final edit). THE CONTRACT (D1-DESIGN §4): unknown step names fall into the ACTIVE stage's
// "working…" line, never crash. D2a refines the mapping; the stage keys are i18n keys.

export const STAGES = [
  { key: 'script', tKey: 'generating.stage.script' },
  { key: 'look', tKey: 'generating.stage.look' },
  { key: 'filming', tKey: 'generating.stage.filming' },
  { key: 'audio', tKey: 'generating.stage.audio' },
  { key: 'edit', tKey: 'generating.stage.edit' },
];

const STEP_TO_STAGE = [
  [/^(research|p1|p2|adherence|quote|start)$/, 'script'],
  [/^(refs|stills|facemap|ref)/, 'look'],
  [/^(render|block|clip|seedance|poll)/, 'filming'],
  [/^(voice|music|sfx|dub|audio|vo)/, 'audio'],
  [/^(assemble|finish|container|overlay|compose|master|upload|sync)/, 'edit'],
];

export function stageForStep(stepName) {
  const s = String(stepName || '').toLowerCase();
  for (const [re, stage] of STEP_TO_STAGE) if (re.test(s)) return stage;
  return null; // unknown -> the caller keeps the current active stage (never crash)
}

export function stageIndex(key) {
  return STAGES.findIndex((s) => s.key === key);
}
